import type {DbrEligibility} from '../dtos';

/** The application override prices the plan; DBR eligibility remains on its configured rate. */
export function resolveAnnualRatePct(
  override: number | null | undefined,
  parameters: {tenorRatesPct?: {tenorYears: number; ratePct: number}[]},
  eligibility: Pick<DbrEligibility, 'tenors'> | undefined,
  tenorYears: number | undefined,
): number | undefined {
  if (override != null) {
    if (!Number.isFinite(override) || override < 0) throw new Error('Annual interest rate must be a finite nonnegative number.');
    return override;
  }
  const tenor = Math.round(tenorYears ?? 0);
  const configured = parameters.tenorRatesPct?.find(row => row.tenorYears === tenor)?.ratePct;
  if (configured !== undefined) return configured;
  const row = eligibility?.tenors?.find(item => item.tenorYears === tenor);
  return row?.ownRatePct ?? row?.annualRatePct;
}
